export default {
  title: {
    id: 'gift_cards_faq_drawer_title',
    defaultMessage: 'Gift Card FAQs',
  },
  question1: {
    id: 'gift_cards_faq_drawer_question1',
    defaultMessage: 'How do you redeem a gift card?',
  },
  answer1: {
    id: 'gift_cards_faq_drawer_answer1',
    defaultMessage:
      'Visit backmarket website and use your single-use code at checkout.',
  },
  question2: {
    id: 'gift_cards_faq_drawer_question2',
    defaultMessage: 'Can I send it to someone in a different country?',
  },
  answer2: {
    id: 'gift_cards_faq_drawer_answer2',
    defaultMessage:
      'For now, only gift cards in USD can be redeemed in the US.',
  },
  question3: {
    id: 'gift_cards_faq_drawer_question3',
    defaultMessage: 'How do returns work with a gift card?',
  },
  answer3: {
    id: 'gift_cards_faq_drawer_answer3',
    defaultMessage:
      'You can return items bought with a gift card within 30 days of receipt even in cases where there are no defects or other discrepancies with the order.',
  },
  seeMoreFAQ: {
    id: 'gift_cards_faq_cta',
    defaultMessage: 'See more FAQ',
  },
  seeMoreFAQLink: {
    id: 'gift_cards_faq_link',
    defaultMessage: 'link to the FAQ page',
  },
}
